import React from 'react';
import { Switch, Route } from 'react-router-dom';
import MapotecaDigital from '.';
import DownloadsAmbiental from './DownloadsAmbiental';
import DownloadsDiversos from './DownloadsDiversos';
import DownloadsEducacao from './DownloadsEducacao';
import DownloadsPoliticoAdministrativo from './DownloadsPoliticoAdministrativo';
import DownloadsSaude from './DownloadsSaude';

function MapotecaDigitalRoutes() {
	return (
		<Switch>
			<Route
				exact
				path="/media/mapoteca-digital/ambiental"
				component={DownloadsAmbiental}
			/>
			<Route
				exact
				path="/media/mapoteca-digital/diversos"
				component={DownloadsDiversos}
			/>
			<Route
				exact
				path="/media/mapoteca-digital/educacao"
				component={DownloadsEducacao}
			/>
			<Route
				exact
				path="/media/mapoteca-digital/politico-administrativo"
				component={DownloadsPoliticoAdministrativo}
			/>
			<Route
				exact
				path="/media/mapoteca-digital/saude"
				component={DownloadsSaude}
			/>
			<Route path="/media/mapoteca-digital" component={MapotecaDigital} />
		</Switch>
	);
}

export default MapotecaDigitalRoutes;
